export default function deprecatedRoute(to, from, next) {
  next('/retailer')
  return
}
